import "core-js/modules/es.object.from-entries.js";
import { createStore, combineReducers } from 'redux';
import isPromise from 'is-promise';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/*
Copyright 2020 Javier Brea

Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
*/


var NAMESPACE = "dataProvider";

var StoreNamespace = /*#__PURE__*/function () {
  function StoreNamespace() {
    _classCallCheck(this, StoreNamespace);

    this._namespace = NAMESPACE;
  }

  _createClass(StoreNamespace, [{
    key: "get",
    value: function get() {
      return this._namespace;
    }
  }, {
    key: "set",
    value: function set(namespace) {
      this._namespace = namespace;
    }
  }, {
    key: "add",
    value: function add(actionName) {
      return "".concat(this._namespace, "/").concat(actionName);
    }
  }]);

  return StoreNamespace;
}();

var storeNamespace = new StoreNamespace();
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */

var objectTag = '[object Object]';
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */

function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;

  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }

  return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */


function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}
/** Used for built-in method references. */


var funcProto = Function.prototype,
    objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */

var objectCtorString = funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString = objectProto.toString;
/** Built-in value references. */

var getPrototype = overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike(value) {
  return !!value && _typeof(value) == 'object';
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */


function isPlainObject(value) {
  if (!isObjectLike(value) || objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }

  var proto = getPrototype(value);

  if (proto === null) {
    return true;
  }

  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

var lodash_isplainobject = isPlainObject;
var automaticIdCounter = 0;
var warnsTraced = {};
var CHILD_EVENT_PREFIX = "child-";
var NEW_PROVIDER_PREFIX = "new-provider-";
var defaultOptions = {
  cache: true,
  cacheTime: null,
  cleanCacheInterval: null,
  reReadDependenciesMaxTime: 5000,
  readAgainMaxTime: 5000,
  cleanCacheThrottle: 0
};
var SELECTORS_TAG = "selector";
var INIT = "init";
var CLEAN_CACHE = "cleanCache";
var RESET_STATE = "resetState";
var READ_START = "readStart";
var READ_SUCCESS = "readSuccess";
var READ_ERROR = "readError";
var MIGRATE_STORE = "migrateStore";
var ANY = "*";
var eventNames = {
  INIT: INIT,
  CLEAN_CACHE: CLEAN_CACHE,
  RESET_STATE: RESET_STATE,
  READ_START: READ_START,
  READ_SUCCESS: READ_SUCCESS,
  READ_ERROR: READ_ERROR,
  ANY: ANY
};

function newProviderEventName(groupId) {
  return "".concat(NEW_PROVIDER_PREFIX).concat(groupId);
}

function childEventName(eventName) {
  return "".concat(CHILD_EVENT_PREFIX).concat(eventName.replace(CHILD_EVENT_PREFIX, ""));
}

function isString(value) {
  return typeof value === "string";
}

function isArray(value) {
  return Array.isArray(value);
}

function isFunction(value) {
  return typeof value === "function";
}

function isUndefined(value) {
  return typeof value === "undefined";
}

function queryId(query) {
  return isUndefined(query) ? query : "(".concat(JSON.stringify(query), ")");
}

function childId(id, query) {
  return "".concat(id).concat(queryId(query));
}

function eventNamespace(eventName, id) {
  return "".concat(eventName, "-").concat(id);
}

function getAutomaticId() {
  automaticIdCounter++;
  return "".concat(Date.now(), "_").concat(automaticIdCounter);
}

function ensureArray(els) {
  return isArray(els) ? els : [els];
}

function removeFalsy(array) {
  return array.filter(function (el) {
    return !!el;
  });
}

function arrayWithoutFalsies(els) {
  return removeFalsy(ensureArray(els));
}

function message(text) {
  return "@data-provider/core: ".concat(text);
}

function warn(text) {
  console.warn(message(text));
}

function warnOnce(text) {
  if (!warnsTraced[text]) {
    warnsTraced[text] = true;
    warn(text);
  }
} // TODO, remove when node 10 is not maintained


function fromEntriesPolyfill(map) {
  return Array.from(map.entries()).reduce(function (accumulator, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    accumulator[key] = value;
    return accumulator;
  }, {});
}

function fromEntries(map) {
  // TODO, remove when node 10 is not maintained
  if (Object.fromEntries) {
    return Object.fromEntries(map);
  }

  return fromEntriesPolyfill(map);
}

function throttle(func, limit) {
  var inThrottle = false;
  var calledWhileInThrottle = false;
  var finishThrottleTimeout = null;

  var checkFinishThrottle = function checkFinishThrottle(context, args) {
    finishThrottleTimeout = setTimeout(function () {
      if (calledWhileInThrottle) {
        inThrottle = true;
        calledWhileInThrottle = false;
        checkFinishThrottle(context, args);
        func.apply(context, args);
      } else {
        inThrottle = false;
      }
    }, limit);
  };

  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var context = this;

    if (!inThrottle || options.force) {
      if (options.force) {
        clearTimeout(finishThrottleTimeout);
      }

      inThrottle = true;
      calledWhileInThrottle = false;
      checkFinishThrottle(context, arguments);
      func.apply(context, arguments);
    } else {
      calledWhileInThrottle = true;
    }
  };
}
/* Backward compatibility with v2. Accepts:
- id as first argument and options as second argument
- options as first argument with id as a property
*/


function providerArgsV3(args) {
  if (isString(args[0])) {
    warnOnce("Passing id as Provider first argument is deprecated. Please migrate to v3 arguments format");
    return [args[0], args[1], args[2]];
  }

  if (!!args[0]) {
    return [args[0].id, args[0], args[1]];
  }

  return args;
}

var DEFAULT_INITAL_STATE = {
  loaded: false,
  loading: false,
  error: null,
  data: undefined
};

var merge = function merge(state, actionIdState, action) {
  return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.id, _objectSpread2(_objectSpread2({}, state[action.id]), actionIdState)));
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case storeNamespace.add(READ_START):
      return merge(state, {
        loading: true
      }, action);

    case storeNamespace.add(READ_SUCCESS):
      return merge(state, {
        loaded: true,
        loading: false,
        data: action.data,
        error: null
      }, action);

    case storeNamespace.add(READ_ERROR):
      return merge(state, {
        loading: false,
        error: action.error
      }, action);

    case storeNamespace.add(RESET_STATE):
      return merge(state, _objectSpread2(_objectSpread2({}, DEFAULT_INITAL_STATE), action.initialState), action);

    case storeNamespace.add(MIGRATE_STORE):
      return _objectSpread2(_objectSpread2({}, state), action.state[storeNamespace.get()]);

    case storeNamespace.add(INIT):
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.id, _objectSpread2(_objectSpread2({}, DEFAULT_INITAL_STATE), action.initialState)));

    default:
      return state;
  }
}

function migrate(state, newNamespace) {
  return {
    baseType: MIGRATE_STORE,
    type: storeNamespace.add(MIGRATE_STORE),
    state: state,
    newNamespace: newNamespace
  };
}

function init(id, initialState) {
  return {
    baseType: INIT,
    type: storeNamespace.add(INIT),
    id: id,
    initialState: initialState
  };
}

function resetState(id, initialState) {
  return {
    baseType: RESET_STATE,
    type: storeNamespace.add(RESET_STATE),
    id: id,
    initialState: initialState
  };
}

function readStart(id) {
  return {
    baseType: READ_START,
    type: storeNamespace.add(READ_START),
    id: id
  };
}

function readSuccess(id, data) {
  return {
    baseType: READ_SUCCESS,
    type: storeNamespace.add(READ_SUCCESS),
    id: id,
    data: data
  };
}

function readError(id, error) {
  return {
    baseType: READ_ERROR,
    type: storeNamespace.add(READ_ERROR),
    id: id,
    error: error
  };
}

var StoreManager = /*#__PURE__*/function () {
  function StoreManager() {
    _classCallCheck(this, StoreManager);

    this._store = createStore(combineReducers(_defineProperty({}, storeNamespace.get(), reducer)));
  }

  _createClass(StoreManager, [{
    key: "setStore",
    value: function setStore(store, namespace) {
      var previousState = this._store.getState();

      this._store = store;

      this._store.dispatch(migrate(previousState, namespace));

      storeNamespace.set(namespace);
    }
  }, {
    key: "reducer",
    get: function get() {
      return reducer;
    }
  }, {
    key: "store",
    get: function get() {
      return this._store;
    }
  }, {
    key: "namespace",
    get: function get() {
      return storeNamespace.get();
    }
  }, {
    key: "state",
    get: function get() {
      return this._store.getState()[storeNamespace.get()];
    }
  }]);

  return StoreManager;
}();

var storeManager = new StoreManager();

var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.events = {};
  }

  _createClass(EventEmitter, [{
    key: "_getEventListByName",
    value: function _getEventListByName(eventName) {
      if (isUndefined(this.events[eventName])) {
        this.events[eventName] = new Set();
      }

      return this.events[eventName];
    }
  }, {
    key: "on",
    value: function on(eventName, fn) {
      this._getEventListByName(eventName).add(fn);

      return this._createRemoveListener(eventName, fn);
    }
  }, {
    key: "once",
    value: function once(eventName, fn) {
      var _this = this;

      var onceFn = function onceFn() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        fn.apply(null, args);

        _this.removeListener(eventName, onceFn);
      };

      this.on(eventName, onceFn);
      return this._createRemoveListener(eventName, onceFn);
    }
  }, {
    key: "emit",
    value: function emit(eventName) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      this._getEventListByName(eventName).forEach(function (fn) {
        fn.apply(null, args);
      });
    }
  }, {
    key: "_createRemoveListener",
    value: function _createRemoveListener(eventName, fn) {
      var _this2 = this;

      return function () {
        _this2.removeListener(eventName, fn);
      };
    }
  }, {
    key: "removeListener",
    value: function removeListener(eventName, fn) {
      this._getEventListByName(eventName)["delete"](fn);
    }
  }]);

  return EventEmitter;
}();

var eventEmitter = new EventEmitter();

var ProvidersHandler = /*#__PURE__*/function () {
  function ProvidersHandler(baseTags) {
    _classCallCheck(this, ProvidersHandler);

    this._newProviderEventName = newProviderEventName(getAutomaticId());
    this._baseTags = removeFalsy(ensureArray(baseTags));
    this._config = {};
    this._providers = new Set();
  }

  _createClass(ProvidersHandler, [{
    key: "_add",
    value: function _add(provider, id) {
      provider._id = id;

      this._providers.add(provider);

      provider.config(this._config);
      eventEmitter.emit(this._newProviderEventName, provider);
      return this;
    }
  }, {
    key: "_run",
    value: function _run(method, options) {
      this._providers.forEach(function (provider) {
        return provider[method](options);
      });

      return this;
    }
  }, {
    key: "_addListener",
    value: function _addListener(method, eventName, fn) {
      var removeListenersFuncs = this.call.apply(this, [method, eventName, fn]);

      var removeListeners = function removeListeners() {
        removeListenersFuncs.forEach(function (removeListener) {
          return removeListener();
        });
      };

      return removeListeners;
    }
  }, {
    key: "onNewProvider",
    value: function onNewProvider(cb) {
      return eventEmitter.on(this._newProviderEventName, cb);
    }
  }, {
    key: "config",
    value: function config(options) {
      var _this = this;

      this._config = _objectSpread2(_objectSpread2({}, this._config), options);

      this._providers.forEach(function (provider) {
        return provider.config(_this._config);
      });

      return this;
    }
  }, {
    key: "cleanCache",
    value: function cleanCache(options) {
      return this._run("cleanCache", options);
    }
  }, {
    key: "cleanDependenciesCache",
    value: function cleanDependenciesCache(options) {
      return this._run("cleanDependenciesCache", options);
    }
  }, {
    key: "resetState",
    value: function resetState() {
      return this._run("resetState");
    }
  }, {
    key: "on",
    value: function on(eventName, fn) {
      return this._addListener("on", eventName, fn);
    }
  }, {
    key: "onChild",
    value: function onChild(eventName, fn) {
      return this._addListener("onChild", eventName, fn);
    }
  }, {
    key: "once",
    value: function once(eventName, fn) {
      return this._addListener("once", eventName, fn);
    }
  }, {
    key: "onceChild",
    value: function onceChild(eventName, fn) {
      return this._addListener("onceChild", eventName, fn);
    }
  }, {
    key: "call",
    value: function call() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var methodName = args[0];
      args.shift();
      return this.elements.map(function (provider) {
        if (provider[methodName] instanceof Function) {
          return provider[methodName].apply(provider, args);
        } else {
          warn("\"".concat(provider._id, "\" has not method \"").concat(methodName, "\""));
        }
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this._providers.clear();

      this._config = {};
      return this;
    }
  }, {
    key: "size",
    get: function get() {
      return this._providers.size;
    }
  }, {
    key: "elements",
    get: function get() {
      return Array.from(this._providers.values());
    }
  }]);

  return ProvidersHandler;
}();

var Providers = /*#__PURE__*/function () {
  function Providers() {
    _classCallCheck(this, Providers);

    this._allProviders = new ProvidersHandler();
    this._tags = new Map();
    this._allProvidersById = new Map();
  }

  _createClass(Providers, [{
    key: "_createIdEmptyGroup",
    value: function _createIdEmptyGroup(id) {
      var providersHandler = new ProvidersHandler();

      this._allProvidersById.set(id, providersHandler);

      return providersHandler;
    }
  }, {
    key: "_createTagEmptyGroup",
    value: function _createTagEmptyGroup(tag) {
      var providersHandler = new ProvidersHandler(tag);

      this._tags.set(tag, providersHandler);

      return providersHandler;
    }
  }, {
    key: "_add",
    value: function _add(provider, id) {
      var _this2 = this;

      var providerId = id || getAutomaticId();

      var idGroup = this._allProvidersById.get(providerId);

      if (idGroup) {
        if (idGroup.size > 0) {
          var originalId = providerId;
          providerId = "".concat(providerId, "-").concat(getAutomaticId());
          warn("Duplicated id \"".concat(originalId, "\". Changed to \"").concat(providerId, "\""));

          this._createIdEmptyGroup(providerId)._add(provider, providerId);
        } else {
          idGroup._add(provider, providerId);
        }
      } else {
        this._createIdEmptyGroup(providerId)._add(provider, providerId);
      }

      this._allProviders._add(provider, providerId);

      provider._tags.forEach(function (tag) {
        _this2.getByTag(tag)._add(provider, providerId);
      });

      return providerId;
    } // For internal usage

  }, {
    key: "clear",
    value: function clear() {
      this._allProvidersById.clear();

      this._tags.clear();

      return this._allProviders.clear();
    } // Public methods

  }, {
    key: "onNewProvider",
    value: function onNewProvider(cb) {
      return this._allProviders.onNewProvider(cb);
    }
  }, {
    key: "getByTag",
    value: function getByTag(tag) {
      return this._tags.get(tag) || this._createTagEmptyGroup(tag);
    }
  }, {
    key: "getById",
    value: function getById(id) {
      return this._allProvidersById.get(id) || this._createIdEmptyGroup(id);
    } // Expose methods of all providers

  }, {
    key: "config",
    value: function config(options) {
      return this._allProviders.config(options);
    }
  }, {
    key: "cleanCache",
    value: function cleanCache(options) {
      return this._allProviders.cleanCache(options);
    }
  }, {
    key: "cleanDependenciesCache",
    value: function cleanDependenciesCache(options) {
      return this._allProviders.cleanDependenciesCache(options);
    }
  }, {
    key: "resetState",
    value: function resetState() {
      return this._allProviders.resetState();
    }
  }, {
    key: "on",
    value: function on(eventName, fn) {
      return this._allProviders.on(eventName, fn);
    }
  }, {
    key: "onChild",
    value: function onChild(eventName, fn) {
      return this._allProviders.onChild(eventName, fn);
    }
  }, {
    key: "once",
    value: function once(eventName, fn) {
      return this._allProviders.once(eventName, fn);
    }
  }, {
    key: "onceChild",
    value: function onceChild(eventName, fn) {
      return this._allProviders.onceChild(eventName, fn);
    }
  }, {
    key: "call",
    value: function call() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this._allProviders.call.apply(this._allProviders, args);
    }
  }, {
    key: "size",
    get: function get() {
      return this._allProviders.size;
    }
  }, {
    key: "elements",
    get: function get() {
      return this._allProviders.elements;
    }
  }]);

  return Providers;
}();

var providers = new Providers();

var Provider = /*#__PURE__*/function () {
  function Provider() {
    _classCallCheck(this, Provider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    } // TODO in V3. Remove backward compatibility


    var _providerArgsV = providerArgsV3(args),
        _providerArgsV2 = _slicedToArray(_providerArgsV, 3),
        id = _providerArgsV2[0],
        options = _providerArgsV2[1],
        query = _providerArgsV2[2];

    this._emitChild = this._emitChild.bind(this);
    this._options = _objectSpread2(_objectSpread2({}, defaultOptions), options);
    this._query = _objectSpread2({}, query);
    this._tags = [].concat(_toConsumableArray(arrayWithoutFalsies(this.baseTags)), _toConsumableArray(arrayWithoutFalsies(this._options.tags)));
    this._children = new Map();
    this._queryMethods = new Map();
    this._queryMethodsParsers = new Map();
    this._id = providers._add(this, id); // initial configuration is made by providers handler

    storeManager.store.dispatch(init(this._id, this.initialState));
  } // Private methods


  _createClass(Provider, [{
    key: "_eventNamespace",
    value: function _eventNamespace(eventName) {
      return eventNamespace(eventName, this._id);
    }
  }, {
    key: "_emitChild",
    value: function _emitChild(eventName, child) {
      this.emit(childEventName(eventName), child);
      eventEmitter.emit(this._eventNamespace(childEventName(ANY)), eventName, child);
    }
  }, {
    key: "_dispatch",
    value: function _dispatch(action) {
      storeManager.store.dispatch(action);
      this.emit(action.baseType);
    }
  }, {
    key: "_cleanCacheInterval",
    value: function _cleanCacheInterval() {
      if (this._cleanCacheIntervalRef) {
        clearInterval(this._cleanCacheIntervalRef);
      }
    }
  }, {
    key: "_setCleanCacheInterval",
    value: function _setCleanCacheInterval(interval, force) {
      var _this = this;

      if (interval) {
        if (interval !== this._previousCleanCacheInterval || force) {
          this._previousCleanCacheInterval = interval;

          this._cleanCacheInterval();

          this._cleanCacheIntervalRef = setInterval(function () {
            _this.cleanCache();
          }, interval);
        }
      } else {
        this._cleanCacheInterval();
      }
    }
  }, {
    key: "_setCleanCacheThrottle",
    value: function _setCleanCacheThrottle(throttleTime) {
      if (throttleTime) {
        if (throttleTime !== this._previousThrottleTime) {
          this._previousThrottleTime = throttleTime;
          this._throttledCleanCache = throttle(this._unthrottledCleanCache.bind(this), throttleTime);
          this._throttledCleanDependenciesCache = throttle(this._unthrottledCleanDependenciesCache.bind(this), throttleTime);
        }
      } else {
        this._throttledCleanCache = this._unthrottledCleanCache;
        this._throttledCleanDependenciesCache = this._unthrottledCleanDependenciesCache;
      }
    }
  }, {
    key: "_unthrottledCleanCache",
    value: function _unthrottledCleanCache(options) {
      // Reset cacheTime counter
      if (this._cacheTimeOut) {
        clearTimeout(this._cacheTimeOut);
        this._cacheTimeOut = null;
      } // Reset cleanCacheInterval


      this._setCleanCacheInterval(this._previousCleanCacheInterval, true);

      this._cache = null;
      this.emit(CLEAN_CACHE);

      this._children.forEach(function (child) {
        return child.cleanCache(options);
      });
    }
  }, {
    key: "_unthrottledCleanDependenciesCache",
    value: function _unthrottledCleanDependenciesCache(options) {
      this.cleanCache(options);
    } // Public methods

  }, {
    key: "config",
    value: function config(options) {
      this._options = _objectSpread2(_objectSpread2({}, this._options), options);

      this._setCleanCacheInterval(this._options.cleanCacheInterval);

      this._setCleanCacheThrottle(this._options.cleanCacheThrottle);

      this.configMethod(this._options);
    }
  }, {
    key: "on",
    value: function on(eventName, fn) {
      return eventEmitter.on(this._eventNamespace(eventName), fn);
    }
  }, {
    key: "onChild",
    value: function onChild(eventName, fn) {
      return eventEmitter.on(this._eventNamespace(childEventName(eventName)), fn);
    }
  }, {
    key: "once",
    value: function once(eventName, fn) {
      return eventEmitter.once(this._eventNamespace(eventName), fn);
    }
  }, {
    key: "onceChild",
    value: function onceChild(eventName, fn) {
      return eventEmitter.once(this._eventNamespace(childEventName(eventName)), fn);
    }
  }, {
    key: "addQuery",
    value: function addQuery(key, queryFunc) {
      var _this2 = this;

      var returnQuery = function returnQuery(query) {
        return _this2.query(queryFunc(query));
      };

      this._queryMethodsParsers.set(key, queryFunc);

      this._queryMethods.set(key, returnQuery);
    }
  }, {
    key: "cleanCache",
    value: function cleanCache(options) {
      this._throttledCleanCache(options);
    }
  }, {
    key: "cleanDependenciesCache",
    value: function cleanDependenciesCache(options) {
      this._throttledCleanDependenciesCache(options);
    }
  }, {
    key: "resetState",
    value: function resetState$1() {
      this._dispatch(resetState(this._id, this.initialState));

      this._children.forEach(function (child) {
        return child.resetState();
      });
    }
  }, {
    key: "read",
    value: function read() {
      var _this3 = this;

      if (this._cache && this._options.cache) {
        return this._cache;
      }

      this._dispatch(readStart(this._id));

      var readPromise;
      var error;

      try {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        readPromise = this.readMethod.apply(this, args);
      } catch (err) {
        error = err;
      }

      if (!isPromise(readPromise)) {
        readPromise = error ? Promise.reject(error) : Promise.resolve(readPromise);
      }

      var resultPromise = readPromise.then(function (result) {
        _this3._dispatch(readSuccess(_this3._id, result));

        if (_this3._options.cacheTime && _this3._options.cacheTime > 0) {
          _this3._cacheTimeOut = setTimeout(function () {
            _this3._cache = null;
          }, _this3._options.cacheTime);
        }

        return Promise.resolve(result);
      })["catch"](function (resultError) {
        _this3._dispatch(readError(_this3._id, resultError));

        _this3._cache = null;
        return Promise.reject(resultError);
      });
      this._cache = resultPromise;
      return this._cache;
    }
  }, {
    key: "query",
    value: function query(_query) {
      var _this4 = this;

      if (isUndefined(_query)) {
        return this;
      }

      var newQuery = this.getChildQueryMethod(_query);
      var id = childId(this._id, newQuery);

      if (this._children.has(id)) {
        return this._children.get(id);
      } // TODO in V3, pass id as property of options, remove id argument


      var child = this.createChildMethod(id, _objectSpread2({}, this._options), newQuery);

      this._queryMethodsParsers.forEach(function (queryMethodParser, queryMethodKey) {
        return child.addQuery(queryMethodKey, queryMethodParser);
      });

      child.on(ANY, function (eventName) {
        return _this4._emitChild(eventName, child);
      });

      this._children.set(id, child);

      child._parent = this;
      return child;
    }
  }, {
    key: "emit",
    value: function emit(eventName, child) {
      eventEmitter.emit(this._eventNamespace(eventName), child);
      eventEmitter.emit(this._eventNamespace(ANY), eventName, child);
    } // Methods that can be overwritten by addons

  }, {
    key: "getChildQueryMethod",
    value: function getChildQueryMethod(query) {
      return _objectSpread2(_objectSpread2({}, this.queryValue), query);
    } // TODO in V3. Remove id argument

  }, {
    key: "createChildMethod",
    value: function createChildMethod(id, options, query) {
      return new this.constructor(id, options, query);
    }
  }, {
    key: "configMethod",
    value: function configMethod() {}
  }, {
    key: "readMethod",
    value: function readMethod() {
      return Promise.resolve(this.state.data);
    }
  }, {
    key: "store",
    get: function get() {
      return storeManager.state[this._id];
    }
  }, {
    key: "state",
    get: function get() {
      return this.store;
    }
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "queryValue",
    get: function get() {
      return this._query;
    }
  }, {
    key: "queries",
    get: function get() {
      return fromEntries(this._queryMethods);
    }
  }, {
    key: "children",
    get: function get() {
      return Array.from(this._children.values());
    }
  }, {
    key: "parent",
    get: function get() {
      return this._parent;
    }
  }, {
    key: "options",
    get: function get() {
      return this._options;
    }
  }, {
    key: "tags",
    get: function get() {
      return this._tags;
    } // Methods to be used for testing

  }, {
    key: "queryMethods",
    get: function get() {
      return fromEntries(this._queryMethodsParsers);
    } // Methods to be used only by addons

  }, {
    key: "initialStateFromOptions",
    get: function get() {
      return isFunction(this._options.initialState) ? this._options.initialState(this._query) : this._options.initialState;
    }
  }, {
    key: "initialState",
    get: function get() {
      return this.initialStateFromOptions;
    }
  }]);

  return Provider;
}();
/*
Copyright 2020 Javier Brea

Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
*/


var CatchDependency = function CatchDependency(dependency, catchMethod) {
  _classCallCheck(this, CatchDependency);

  this.dependency = dependency;
  this["catch"] = catchMethod;
};
/*
Copyright 2019 Javier Brea
Copyright 2019 XbyOrange

Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
*/


function catchDependency(dependency, catchMethod) {
  return new CatchDependency(dependency, catchMethod);
}

function isDataProvider(objectToCheck) {
  return objectToCheck && objectToCheck instanceof Provider;
}

function isCatchedDependency(objectToCheck) {
  return objectToCheck && objectToCheck instanceof CatchDependency;
}

function isDependency(objectToCheck) {
  if (!objectToCheck) {
    return false;
  }

  return isDataProvider(objectToCheck) || isFunction(objectToCheck) || isCatchedDependency(objectToCheck);
}

function isDependencyExpression(arrayToCheck) {
  return ensureArray(arrayToCheck).reduce(function (allAreDataProviders, arrayElement) {
    if (!allAreDataProviders || !isDependency(arrayElement)) {
      return false;
    }

    return true;
  }, true);
}

function resolveResult(result) {
  return isPromise(result) ? result : Promise.resolve(result);
}

var SelectorBase = /*#__PURE__*/function (_Provider) {
  _inherits(SelectorBase, _Provider);

  var _super = _createSuper(SelectorBase);

  function SelectorBase(id, options, query) {
    var _this;

    _classCallCheck(this, SelectorBase);

    _this = _super.call(this, id, options, query);
    warnOnce("Usage of deprecated Selector detected. You should use SelectorV3 to prepare migration to v3");
    _this._dependencies = options._dependencies;
    _this._resolvedDependencies = [];
    _this._selector = options._selector;
    _this._inProgressDependencies = new Set();
    return _this;
  } // Private methods


  _createClass(SelectorBase, [{
    key: "_readAllDependenciesAndSelect",
    value: function _readAllDependenciesAndSelect() {
      var _this2 = this;

      var dependenciesResults;
      var dependencies;
      var dependenciesListeners;
      var hasToReadAgain = false;
      var reReadMaxTimeReached = false;
      var inProgressListeners = [];
      var reReadTimeOut = setTimeout(function () {
        reReadMaxTimeReached = true;
      }, this._options.reReadDependenciesMaxTime);

      if (this._readInProgress) {
        clearTimeout(reReadTimeOut);
        return this._readInProgress;
      }

      var markToReadAgain = function markToReadAgain() {
        if (!reReadMaxTimeReached) {
          hasToReadAgain = true;
        }
      };

      var markToNotReadAgain = function markToNotReadAgain() {
        hasToReadAgain = false;
      };

      var removeInProgressListenerFuncs = function removeInProgressListenerFuncs() {
        inProgressListeners.forEach(function (removeListener) {
          return removeListener();
        });
        _this2._resolvedDependencies = Array.from(_this2._inProgressDependencies);

        _this2._inProgressDependencies.clear();
      };

      var cleanCache = function cleanCache() {
        dependenciesListeners.forEach(function (removeListener) {
          return removeListener();
        });

        _this2.cleanCache({
          force: true
        });
      };

      var readDependency = function readDependency(dependencyToRead, catchMethod) {
        if (hasToReadAgain) {
          return Promise.resolve();
        }

        if (isArray(dependencyToRead)) {
          return Promise.all(dependencyToRead.map(function (dep) {
            return readDependency(dep, catchMethod);
          }));
        }

        if (isFunction(dependencyToRead)) {
          return readDependency(dependencyToRead(_this2._query, dependenciesResults), catchMethod);
        }

        if (isCatchedDependency(dependencyToRead)) {
          return readDependency(dependencyToRead.dependency, dependencyToRead["catch"]);
        }

        if (!isDataProvider(dependencyToRead)) {
          return resolveResult(dependencyToRead);
        }

        dependencies.push(dependencyToRead);

        if (!_this2._inProgressDependencies.has(dependencyToRead)) {
          _this2._inProgressDependencies.add(dependencyToRead);

          inProgressListeners.push(dependencyToRead.on(CLEAN_CACHE, markToReadAgain));
        }

        return dependencyToRead.read()["catch"](function (error) {
          if (catchMethod) {
            var catchResult = catchMethod(error, _this2._query, dependenciesResults);

            if (isDependencyExpression(catchResult)) {
              return readDependency(catchResult);
            }

            return catchResult;
          }

          return Promise.reject(error);
        });
      };

      var readDependencies = function readDependencies() {
        var dependencyIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        if (hasToReadAgain) {
          return Promise.resolve();
        }

        if (dependencyIndex === 0) {
          dependenciesResults = [];
          dependencies = [];
        }

        return readDependency(_this2._dependencies[dependencyIndex]).then(function (dependencyResult) {
          dependenciesResults.push(dependencyResult);

          if (dependencyIndex < _this2._dependencies.length - 1) {
            return readDependencies(dependencyIndex + 1);
          }

          var result = _this2._selector.apply(null, dependenciesResults.concat(_this2._query));

          return resolveResult(result);
        });
      };

      var addCleanListeners = function addCleanListeners() {
        dependenciesListeners = dependencies.map(function (dependency) {
          return dependency.once(CLEAN_CACHE, cleanCache);
        });
      };

      var readAndReturn = function readAndReturn() {
        return readDependencies().then(function (result) {
          if (isDependencyExpression(result)) {
            return readDependency(result);
          }

          return Promise.resolve(result);
        }).then(function (result) {
          if (hasToReadAgain) {
            markToNotReadAgain();
            return readAndReturn();
          }

          clearTimeout(reReadTimeOut);
          removeInProgressListenerFuncs();
          addCleanListeners();
          return Promise.resolve(result);
        })["catch"](function (error) {
          if (hasToReadAgain) {
            markToNotReadAgain();
            return readAndReturn();
          }

          clearTimeout(reReadTimeOut);
          removeInProgressListenerFuncs();
          addCleanListeners();
          return Promise.reject(error);
        });
      };

      this._readInProgress = readAndReturn().then(function (result) {
        _this2._readInProgress = null;
        return Promise.resolve(result);
      })["catch"](function (error) {
        _this2._readInProgress = null;
        return Promise.reject(error);
      });
      return this._readInProgress;
    }
  }, {
    key: "_cleanCaches",
    value: function _cleanCaches(dependencies, options) {
      dependencies.forEach(function (dependency) {
        if (!options.except || !options.except.includes(dependency) && !options.except.includes(dependency.parent)) {
          dependency.cleanDependenciesCache(options);
        }
      });
    } // Overwrite Provider methods

  }, {
    key: "readMethod",
    value: function readMethod() {
      return this._readAllDependenciesAndSelect();
    }
  }, {
    key: "configMethod",
    value: function configMethod(options) {
      var _this3 = this;

      if (options.getChildQueryMethod) {
        this.getChildQueryMethod = function (query) {
          return options.getChildQueryMethod(query, _this3.queryValue);
        };
      }
    }
  }, {
    key: "_unthrottledCleanDependenciesCache",
    value: function _unthrottledCleanDependenciesCache() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var dependenciesToClean = new Set(this._resolvedDependencies);

      this._inProgressDependencies.forEach(function (dependency) {
        dependenciesToClean.add(dependency);
      });

      this._cleanCaches(Array.from(dependenciesToClean), options);
    } // Define base tag

  }, {
    key: "baseTags",
    get: function get() {
      return SELECTORS_TAG;
    } // Methods to be used for testing

  }, {
    key: "dependencies",
    get: function get() {
      return this._dependencies;
    }
  }, {
    key: "selector",
    get: function get() {
      return this._selector;
    }
  }, {
    key: "options",
    get: function get() {
      var _this4 = this;

      return Object.keys(this._options).reduce(function (opts, key) {
        // Remove Selector private options
        if (key.indexOf("_") !== 0) {
          opts[key] = _this4._options[key];
        }

        return opts;
      }, {});
    }
  }]);

  return SelectorBase;
}(Provider); // Expose a different interface for Selectors the first time, but children are built with the same interface than providers internally


var Selector = /*#__PURE__*/function (_SelectorBase) {
  _inherits(Selector, _SelectorBase);

  var _super2 = _createSuper(Selector);

  function Selector() {
    _classCallCheck(this, Selector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var lastIndex = args.length - 1;
    var selectorIndex = lastIndex;
    var options = {};

    if (!isFunction(args[lastIndex])) {
      selectorIndex = args.length - 2;
      options = args[lastIndex];
    }

    options._dependencies = args.slice(0, selectorIndex);
    options._selector = args[selectorIndex];
    return _super2.call(this, options.id, options);
  } // Overwrite Provider methods


  _createClass(Selector, [{
    key: "createChildMethod",
    value: function createChildMethod(id, options, query) {
      return new SelectorBase(id, options, query);
    }
  }]);

  return Selector;
}(SelectorBase);

var SelectorV3Base = /*#__PURE__*/function (_Provider) {
  _inherits(SelectorV3Base, _Provider);

  var _super = _createSuper(SelectorV3Base);

  function SelectorV3Base(options, query) {
    var _this;

    _classCallCheck(this, SelectorV3Base);

    _this = _super.call(this, options, query);
    _this._dependencies = options._dependencies;
    _this._dependenciesResolved = [];
    _this._dependenciesInProgress = new Set();
    return _this;
  } // Private methods


  _createClass(SelectorV3Base, [{
    key: "_readAllDependencies",
    value: function _readAllDependencies() {
      var _this2 = this;

      var dependenciesResults;
      var dependencies;
      var dependenciesListeners;
      var hasToReadAgain = false;
      var readAgainMaxTimeReached = false;
      var inProgressListeners = [];
      var readAgainTimeOut = setTimeout(function () {
        readAgainMaxTimeReached = true;
      }, this._options.readAgainMaxTime);

      if (this._readInProgress) {
        clearTimeout(readAgainTimeOut);
        return this._readInProgress;
      }

      var markToReadAgain = function markToReadAgain() {
        if (!readAgainMaxTimeReached) {
          hasToReadAgain = true;
        }
      };

      var markToNotReadAgain = function markToNotReadAgain() {
        hasToReadAgain = false;
      };

      var removeInProgressListenerFuncs = function removeInProgressListenerFuncs() {
        inProgressListeners.forEach(function (removeListener) {
          return removeListener();
        });
        _this2._dependenciesResolved = Array.from(_this2._dependenciesInProgress);

        _this2._dependenciesInProgress.clear();
      };

      var cleanCache = function cleanCache() {
        dependenciesListeners.forEach(function (removeListener) {
          return removeListener();
        });

        _this2.cleanCache({
          force: true
        });
      };

      var readDependency = function readDependency(dependencyToRead, catchMethod) {
        var catchError = function catchError(promise) {
          return promise["catch"](function (error) {
            if (catchMethod) {
              return readDependency(catchMethod.apply(catchMethod, [error, _this2._query].concat(dependenciesResults)));
            }

            return Promise.reject(error);
          });
        };

        if (hasToReadAgain) {
          return Promise.resolve();
        }

        if (isCatchedDependency(dependencyToRead)) {
          return readDependency(dependencyToRead.dependency, dependencyToRead["catch"]);
        }

        if (isArray(dependencyToRead)) {
          return Promise.all(dependencyToRead.map(function (dep) {
            return readDependency(dep, catchMethod);
          }));
        }

        if (isFunction(dependencyToRead)) {
          return readDependency(dependencyToRead.apply(dependencyToRead, [_this2._query].concat(dependenciesResults)), catchMethod);
        }

        if (isPromise(dependencyToRead)) {
          return catchError(dependencyToRead.then(function (result) {
            return readDependency(result);
          }));
        }

        if (!isDataProvider(dependencyToRead)) {
          return resolveResult(dependencyToRead);
        }

        dependencies.push(dependencyToRead);

        if (!_this2._dependenciesInProgress.has(dependencyToRead)) {
          _this2._dependenciesInProgress.add(dependencyToRead);

          inProgressListeners.push(dependencyToRead.on(CLEAN_CACHE, markToReadAgain));
        }

        return catchError(dependencyToRead.read());
      };

      var readDependencies = function readDependencies() {
        var dependencyIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        if (hasToReadAgain) {
          return Promise.resolve();
        }

        if (dependencyIndex === 0) {
          dependenciesResults = [];
          dependencies = [];
        }

        return readDependency(_this2._dependencies[dependencyIndex]).then(function (dependencyResult) {
          dependenciesResults.push(dependencyResult);

          if (dependencyIndex < _this2._dependencies.length - 1) {
            return readDependencies(dependencyIndex + 1);
          }

          return resolveResult(dependencyResult);
        });
      };

      var addCleanListeners = function addCleanListeners() {
        dependenciesListeners = dependencies.map(function (dependency) {
          return dependency.once(CLEAN_CACHE, cleanCache);
        });
      };

      var readAndReturn = function readAndReturn() {
        return readDependencies().then(function (result) {
          if (hasToReadAgain) {
            markToNotReadAgain();
            return readAndReturn();
          }

          clearTimeout(readAgainTimeOut);
          removeInProgressListenerFuncs();
          addCleanListeners();
          return Promise.resolve(result);
        })["catch"](function (error) {
          if (hasToReadAgain) {
            markToNotReadAgain();
            return readAndReturn();
          }

          clearTimeout(readAgainTimeOut);
          removeInProgressListenerFuncs();
          addCleanListeners();
          return Promise.reject(error);
        });
      };

      this._readInProgress = readAndReturn().then(function (result) {
        _this2._readInProgress = null;
        return Promise.resolve(result);
      })["catch"](function (error) {
        _this2._readInProgress = null;
        return Promise.reject(error);
      });
      return this._readInProgress;
    }
  }, {
    key: "_cleanCaches",
    value: function _cleanCaches(dependencies, options) {
      dependencies.forEach(function (dependency) {
        if (!options.except || !options.except.includes(dependency) && !options.except.includes(dependency.parent)) {
          dependency.cleanDependenciesCache(options);
        }
      });
    } // Overwrite Provider methods

  }, {
    key: "readMethod",
    value: function readMethod() {
      return this._readAllDependencies();
    }
  }, {
    key: "configMethod",
    value: function configMethod(options) {
      var _this3 = this;

      if (options.getChildQueryMethod) {
        this.getChildQueryMethod = function (query) {
          return options.getChildQueryMethod(query, _this3.queryValue);
        };
      }
    }
  }, {
    key: "_unthrottledCleanDependenciesCache",
    value: function _unthrottledCleanDependenciesCache() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var dependenciesToClean = new Set(this._dependenciesResolved);

      this._dependenciesInProgress.forEach(function (dependency) {
        dependenciesToClean.add(dependency);
      });

      this._cleanCaches(Array.from(dependenciesToClean), options);
    } // Define base tag

  }, {
    key: "createChildMethod",
    // Overwrite Provider methods
    // TODO in V3. Remove id argument.
    value: function createChildMethod(id, options, query) {
      return new SelectorV3Base(_objectSpread2(_objectSpread2({}, options), {}, {
        id: id
      }), query);
    }
  }, {
    key: "baseTags",
    get: function get() {
      return SELECTORS_TAG;
    } // Methods to be used for testing

  }, {
    key: "dependencies",
    get: function get() {
      return this._dependencies;
    }
  }, {
    key: "options",
    get: function get() {
      var _this4 = this;

      return Object.keys(this._options).reduce(function (opts, key) {
        // Remove Selector private options
        if (key.indexOf("_") !== 0) {
          opts[key] = _this4._options[key];
        }

        return opts;
      }, {});
    }
  }]);

  return SelectorV3Base;
}(Provider); // Use different arguments for Selectors the first time, but children are built with the same interface than providers internally


var SelectorV3 = /*#__PURE__*/function (_SelectorV3Base) {
  _inherits(SelectorV3, _SelectorV3Base);

  var _super2 = _createSuper(SelectorV3);

  function SelectorV3() {
    _classCallCheck(this, SelectorV3);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var lastIndex = args.length - 1;
    var dependenciesNumber = args.length;
    var options = {};

    if (lodash_isplainobject(args[lastIndex])) {
      dependenciesNumber = dependenciesNumber - 1;
      options = _objectSpread2({}, args[lastIndex]);
    }

    options._dependencies = args.slice(0, dependenciesNumber);
    return _super2.call(this, options);
  } // Overwrite Provider methods
  // TODO in V3. Remove id argument.


  _createClass(SelectorV3, [{
    key: "createChildMethod",
    value: function createChildMethod(id, options, query) {
      return new SelectorV3Base(_objectSpread2(_objectSpread2({}, options), {}, {
        id: id
      }), query);
    }
  }]);

  return SelectorV3;
}(SelectorV3Base);

export { Provider, Selector, SelectorV3, catchDependency, eventNames, providerArgsV3, providers, storeManager };